export const hospitalSampleAction = (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }